import styles from './index.css';

// Please replace, if IE11-support isn't required any longer.
//import {useFormContext} from 'react-hook-form';
import {useFormContext} from 'react-hook-form/dist/react-hook-form.ie11';

import * as React from 'react';
import {get}from 'lodash';
import classNames from 'classnames';

import {Option} from '../../Definitions';
import Icon from '../Icon';
import CheckIndicator from '../CheckIndicator';
import {useArrayUpdater, useHandlerOnOuterClick} from '../../Utils/Hooks';
import { readdirSync } from 'fs';

type MultiSelectboxProps = {
	name: string;
	options: Option[];
	required?: boolean;
	hasLoader: boolean;
	className?: string;
}
export default (props: MultiSelectboxProps) => {
	const {name = '', required, options = [], hasLoader, className} = props;

	if (!name) {
		console.warn('Missing prop "name" or "onSelect" for MultiSelectbox.');
		return null;
	}

	if (!(hasLoader || options.length)) {
		console.warn('Missing "options" for MultiSelectbox.');
		return null;
	}

	const {register, errors, getValues, watch} = useFormContext();
	const isInvalid = Boolean(get(errors, name));

	// Toggle-state.
	const [isOpen, setIsOpen] = React.useState(false);
	const toggle = () => setIsOpen(!isOpen);
	const close = () => setIsOpen(false);
	const {node, enableHandler, disableHandler} = useHandlerOnOuterClick(close, false);

	React.useEffect(() => {
		if (isOpen) {
			enableHandler();
		} else {
			disableHandler();
		}
	}, [isOpen]);

	const update = useArrayUpdater(name);
	const isWaiting = hasLoader && options.length === 0;

	let selectedValues: any[] = [];

	if (!isWaiting) {
		selectedValues = get(getValues({nest: true}), name, []);
	}

	const selectedOptions = options.filter(({value}) => selectedValues.includes(value));
	const isChecked = (value: number|string) => selectedValues.includes(value);

	return (
		<div
			ref={node}
			className={classNames(
				styles.multiSelectbox,
				isOpen && styles.isOpen,
				isWaiting && styles.isWaiting,
				isInvalid && styles.isInvalid,
				!selectedValues.length && required && styles.isRequired,
				className
			)}
		>
			<div
				onClick={isWaiting ? () => {} : toggle}
				className={styles.toggler}
			>
				{
					selectedOptions.map(({value, label}) => (
						<div
							key={value}
							className={styles.item}
						>
							<span>{label || value}</span>
							<Icon
								name="times"
								onClick={(e: React.SyntheticEvent) => {
									update(value);
									e.stopPropagation();
								}}
								className={styles.icon}
							/>
						</div>

					))
				}
				{
					isWaiting &&
						<Icon name="spinner" rotates className={styles.icon}/>
				}
				{
					!isWaiting &&
						<Icon name="chevron-down" isFlipped={isOpen} className={styles.icon}/>
				}
			</div>
			<div className={styles.options}>
				{
					options.map(({value, label}) => (
						<React.Fragment key={value}>
							<input type="checkbox" value={value} name={name} ref={register({required})}/>
							<div
								key={value}
								className={styles.option}
								onClick={() => update(value)}
							>
								<CheckIndicator isChecked={isChecked(value)} className={styles.check}/>
								<span>{label || value}</span>
							</div>
						</React.Fragment>
					))
				}
			</div>
		</div>
	);
}
